import { render } from "./BlogThreeColumn2.vue?vue&type=template&id=10ffcef9&scoped=true"
import script from "./BlogThreeColumn2.vue?vue&type=script&lang=js"
export * from "./BlogThreeColumn2.vue?vue&type=script&lang=js"

import "./BlogThreeColumn2.vue?vue&type=style&index=0&id=10ffcef9&scoped=true&lang=scss"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ffcef9"]])

export default __exports__